// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"main-nav-module__mainNav___lzRxj","logo":"main-nav-module__logo___3VOOC","welcome":"main-nav-module__welcome___1TuqD"};